import React from "react";
import DeclaracionBien from "./DeclaracionBien";
import { TituloTabla } from "../../shared/Estilos";
import { clienteAxios, useLog, Swal } from "../../shared/";

const ListarDeclaracionesBienes = ({
  lista,
  openModal,
  setSeleccionado,
  setConsultar,
  soloLectura
}) => {

  const [InsertarLog] = useLog(null);


  const borrar = async (id) => {
    try {
      await clienteAxios.delete("/personasdeclaracion", {
        params: { id },
      });
      InsertarLog( "eliminar", "Eliminacion de Declaracion de Bien");
      setConsultar(true);
    } catch (e) {
    }
  };

  const editar = (item) => {
    setSeleccionado(item);
    openModal();
  };

  const eliminar = (item) => {
    Swal.fire({
      title: "Esta Seguro que desea Eliminar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        borrar(item.id);
      }
    });
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped" style={{backgroundColor:"white"}}>
        <TituloTabla>
          <tr>
            <th scope="col" className="text-center">
            Tipo
            </th>
            <th scope="col" className="text-center">
            Descripción
            </th>
            <th scope="col" className="text-center">
            Detalle
            </th>
            <th scope="col" className="text-center">
              Acciones
            </th>
          </tr>
        </TituloTabla>
        <tbody>
          {lista.map((item) => (
            <DeclaracionBien
              key={item.id}
              item={item}
              editar={editar}
              eliminar={eliminar}
              soloLectura={soloLectura}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListarDeclaracionesBienes;
